"use client";
import React from "react";
import useOnScreen from "@/src/hooks/useOnScreen";
import { AnimatedMobileMenuItemProps } from "./types";

const AnimatedMobileMenuItem: React.FC<AnimatedMobileMenuItemProps> = ({
  name,
  onClick,
  delay,
}) => {
  const { ref, isIntersecting } = useOnScreen<HTMLLIElement>(0.1, false);

  return (
    <li
      ref={ref}
      className={`transition-transform duration-500 ease-in-out ${
        isIntersecting
          ? "translate-x-0 opacity-100"
          : "-translate-x-full opacity-0"
      }`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      <button className="menu-item" onClick={onClick}>
        {name}
      </button>
    </li>
  );
};

export default AnimatedMobileMenuItem;
